module.exports = __webpack_public_path__ + "img/solution3.661c5e78.png";